import { Schedule } from "../../../../types/schedule/schedule";
import { ScheduleState } from "../../../type/schedule-state";

interface Action {
  type: string;
  payload: {
    dialogSchedule: Schedule;
    dialogDeliveryGroupIndex: number;
  };
}

export const setDialogScheduleDispatch = (
  state: ScheduleState,
  action: Action
) => {
  const { dialogSchedule, dialogDeliveryGroupIndex } = action.payload;
  state.dialogSchedule = dialogSchedule;
  state.dialogDeliveryGroupIndex = dialogDeliveryGroupIndex;
};
